// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"modalsearch_modalContainer__7yEFf","modalContent":"modalsearch_modalContent__mOegA","closeIcon":"modalsearch_closeIcon__XKvGi"};